import React from "react";
import StarImg from "../../assets/images/star.svg";
import HalfStarImg from "../../assets/images/HalfStar.svg";
import badReview from "../../assets/images/bad-review 1.svg";
import GrayStarImg from "../../assets/images/GrayStar.svg";
import Line from "../../assets/images/Line 7.svg";

const Reviews = ({ reviews }) => {

  const avgRating = reviews?.avg
    ? Number(reviews.avg.toString().slice(0, 4))
    : 0;
  const integerPart = Math.floor(avgRating);
  const hasHalfStar = avgRating % 1 !== 0;

  const getDaysAgo = (dateString) => {
    const reviewDate = new Date(dateString);
    const today = new Date();

    // حساب الفرق بالملي ثانية، ثم نحوله لأيام
    const diffTime = today - reviewDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "اليوم";
    if (diffDays === 1) return "منذ يوم";
    return `منذ ${diffDays} يوم`;
  };

  return (
    <div className="container-product">
      { reviews?.reviews.length !== 0 ? (
        <div>
          {/* Summary about reviews */}
          <div className="review-summary">
            <div className="content">
              <h2>{avgRating}</h2>
              <div className="stars">
                {Array.from({ length: 5 }).map((_, index) => {
                  if (index < integerPart) {
                    // Full star
                    return <img key={index} width={15} src={StarImg} />;
                  } else if (index === integerPart && hasHalfStar) {
                    // Half star
                    return <img key={index} width={15} src={HalfStarImg} />;
                  } else {
                    // Grey star
                    return <img key={index} width={15} src={GrayStarImg} />;
                  }
                })}
              </div>
              <p className="count">{reviews.count} تقييم</p>
            </div>

            <img src={Line} alt="Line" className="line" />

            <div className="progress-rating">
              {reviews.ratings_count?.map((review, index) => (
                <div key={index} className="progress-rating-item">
                  <div className="rating-label">{review.rating}</div>
                  <div className="progress-bar-container">
                    <div
                      className="progress-bar"
                      style={{ width: `${(review.count / 5) * 100}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* End summary about reviews */}

          <hr />

          {reviews.reviews?.map((review, index) => (
            <div key={index}>
              <div className="review">
                <div className="content">
                  <div className="date">
                    <h3>{review.username}</h3>
                    <p>( {getDaysAgo(review.created_at)})</p>
                  </div>
                  <p>{review.review}</p>
                </div>
                <div className="rate">
                  <div className="icons">
                    <img src={StarImg} width={15} alt="star" />
                  </div>
                  <div className="num">{review.rating}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-data">
          <img src={badReview} alt="bad-review" />
          <h6>لايوجد مراجعات</h6>
        </div>
      )}
    </div>
  );
};

export default Reviews;
